// WhatsApp utility helpers. Number is a placeholder per user instructions.
export const WHATSAPP_NUMBER = "00000000000";

export const buildWhatsAppLink = (message = "Hola Aitor, quiero CAMBIO") => {
  const encoded = encodeURIComponent(message);
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encoded}`;
};

export const openWhatsApp = (message) => {
  const url = buildWhatsAppLink(message);
  window.open(url, "_blank", "noopener,noreferrer");
};
